<template>
    <Modal @cancel="modalEquipementCancel">
        <ModalCard
            @cancel="modalEquipementCancel"
            :noPaddingTop="true"
            :withoutBotNav="true"
            :headerTitle="$t('preventif.suivi.modal.equipment.title')"
            :active-validate="false"
            class="page"
        >
            <div class="tabNav">
                <div @click="this.switchTabActivated(0)" :class="tabActivated === 0 && 'active'">
                    {{ $t('preventif.suivi.modal.equipment.nav.history') }}
                </div>
                <div @click="this.switchTabActivated(1)" :class="tabActivated === 1 && 'active'">
                    {{ $t('preventif.suivi.modal.equipment.nav.caracteristics') }}
                </div>
                <div @click="this.switchTabActivated(2)" :class="tabActivated === 2 && 'active'" v-if="!preventif">
                    {{ $t('preventif.suivi.modal.equipment.nav.gamme.maintenance') }}
                </div>
            </div>
            <div class="modalcontent" v-if="this.tabActivated === 0">
                <HistoriqueEquipement :preventif="preventif" :phase-id="phaseId"/>
            </div>
            <div class="modalcontent" v-if="this.tabActivated === 1">
                <CaracteristiquesEquipement/>
            </div>
            <div class="modalcontent" v-if="this.tabActivated === 2">
                <GammeMaintenance/>
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import ModalCard from '@/components/ui-components/ModalCard.vue';
import Modal from '@/components/ui-components/Modal.vue';
import { defineComponent } from 'vue';
import HistoriqueEquipement from '@/modules/Preventif/components/HistoriqueEquipement.vue';
import CaracteristiquesEquipement from '@/modules/Preventif/components/CaracteristiquesEquipement.vue';
import { EQUIPEMENT_INTERVENTIONS } from '@/modules/Preventif/store/modules/mutation-types';
import GammeMaintenance from '@/modules/Preventif/components/GammeMaintenance.vue';

export default defineComponent({
    data() {
        return {
            tabActivated: 0,
        };
    },
    props: {
        preventif: { type: Boolean, required: true },
        phaseId: { type: Number, required: false }
    },
    components: {CaracteristiquesEquipement, HistoriqueEquipement, GammeMaintenance, ModalCard, Modal},
    methods: {
        switchTabActivated(value: number) {
            this.tabActivated = value;
        },
        modalEquipementCancel() {
            this.$store.commit(EQUIPEMENT_INTERVENTIONS.RESET);
            this.$emit('cancel');
        },
    },
});
</script>

<style scoped>
.tabNav {
    display: flex;
    width: 100%;
    font-size: 14px;
    background: #FFFFFF;
    z-index: 10;
    position: sticky;
    top: 0;
}
.tabNav div {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 50%;
    height: 50px;
    color: rgba(0, 0, 0, 0.54);
    cursor: pointer;

    font-family: 'Raleway Semi Bold', sans-serif !important;
}
.tabNav div.active {
    color: var(--header-blue);
    border-bottom: 2px solid var(--header-blue);
}
.modalcontent {
    padding: 8px 16px;
    width: 50vw;
    height: 50vh;
    overflow: auto;
}
</style>
